import { VercelBlobClientStorage } from './vercel-blob-client';

export type ClientFileStorage = {
  uploadFile(
    pathname: string,
    file: File,
    options: {
      contentType: string;
      clientPayload: string;
      onProgress?: (percentage: number) => void;
    }
  ): Promise<{ pathname: string }>;
};

let instance: ClientFileStorage | undefined;

export function getClientFileStorage(): ClientFileStorage {
  instance ??= new VercelBlobClientStorage();
  return instance;
}

export function setClientFileStorageForTests(
  storage: ClientFileStorage | undefined
): void {
  instance = storage;
}
